import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  FaEye,
  FaTrash,
  FaEdit,
  FaUsers,
  FaPlus,
  FaUsersCog,
  FaHome,
  FaArrowLeft,
  FaFutbol
} from 'react-icons/fa';


const EditTeam = () => {
  const { gameId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [mainTeam, setMainTeam] = useState([]);
  const [reserves, setReserves] = useState([]);
  const [error, setError] = useState('');
  const [maxPlayers, setMaxPlayers] = useState(0);

  const authToken = localStorage.getItem('authToken');

const refreshTeamData = async () => {
  try {
    const [teamRes, gameRes] = await Promise.all([
      fetch(`/api/games/${gameId}/team`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
      }),
      fetch(`/api/games/${gameId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
      }),
    ]);

    if (!teamRes.ok || !gameRes.ok) {
      throw new Error('Failed to fetch team or game info');
    }

    const teamData = await teamRes.json();
    const gameData = await gameRes.json();

    setMainTeam(Array.isArray(teamData.mainTeam) ? teamData.mainTeam : []);
    setReserves(Array.isArray(teamData.reserves) ? teamData.reserves : []);

    const fetchedGame = gameData.game || gameData;
    setMaxPlayers(fetchedGame.max_players || 0);
  } catch (err) {
    setError(err.message);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    refreshTeamData();
  }, [gameId]);

const updateSinglePlayerTeamStatus = async (user_id, newTeam) => {
  try {
    const res = await fetch('/api/rsvps/admin/update-team', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        userId: user_id,
        gameId: gameId,
        newTeam: newTeam,
      }),
    });

    if (!res.ok) {
      console.error(`Failed to update ${user_id} to ${newTeam}`);
    }
  } catch (err) {
    console.error('Error updating team status:', err);
  }
};

const moveToReserves = async (user) => {
  if (!user.user_id) return alert('User ID missing!');
  await updateSinglePlayerTeamStatus(user.user_id, 'reserves');
  await refreshTeamData();
};

  const moveToMain = async (user) => {
    if (!user.user_id) return alert('User ID missing!');
    if (mainTeam.length >= maxPlayers) {
      return alert(`Main team is full (max ${maxPlayers} players).`);
    }

    await updateSinglePlayerTeamStatus(user.user_id, 'main');
    await refreshTeamData();
  };

  const removeFromGame = async (user) => {
    if (!user.user_id) {
      alert('Cannot remove user: ID missing.');
      return;
    }

    try {
      const res = await fetch(`/api/games/${gameId}/remove-player/${user.user_id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.message || 'Failed to remove player');
      }

      await refreshTeamData();
    } catch (err) {
      alert(err.message);
    }
  };

  const saveChanges = async () => {
    try {
      const res = await fetch(`/api/games/${gameId}/team`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          mainTeam,
          reserves,
        }),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.message || 'Failed to update team');
      }

      alert('Team updated!');
      navigate(`/games/${gameId}`);
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <div style={styles.loading}>Loading team data...</div>;
  if (error) return <div style={styles.error}>{error}</div>;

  return (
    <div style={styles.container}>
      <h2>Edit Team</h2>

      <div style={styles.section}>
        <h3>Main Team</h3>
        {mainTeam.length === 0 ? (
          <p>No one in main team</p>
        ) : (
          mainTeam.map(user => (
            <div key={user.user_id} style={styles.userRow}>
              <span>{user.name} {user.surname}</span>
              <div>
                <button onClick={() => moveToReserves(user)} style={styles.button}>
                  To Reserves
                </button>
                <button onClick={() => removeFromGame(user)} style={styles.remove}>
                  Remove
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      <div style={styles.section}>
        <h3>Reserves</h3>
        {reserves.length === 0 ? (
          <p>No one in reserves</p>
        ) : (
          reserves.map(user => (
            <div key={user.user_id} style={styles.userRow}>
              <span>{user.name} {user.surname}</span>
              <div>
                <button onClick={() => moveToMain(user)} style={styles.button}>
                  To Main
                </button>
                <button onClick={() => removeFromGame(user)} style={styles.remove}>
                  Remove
                </button>
              </div>
            </div>
          ))
        )}
      </div>

<div className="button-group" style={{ marginTop: '10px' }}>
  <button onClick={() => navigate(-1)} className="btn btn-primary">
    <FaArrowLeft /> Back
  </button>
</div>
    </div>
  );
};

const styles = {
  container: { maxWidth: 700, margin: 'auto', padding: 20 },
  section: { marginBottom: 30 },
  userRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid #ccc',
  },
  button: { marginRight: 8, cursor: 'pointer' },
  remove: {
    backgroundColor: '#f44336',
    color: 'white',
    cursor: 'pointer',
    padding: '4px 8px',
    border: 'none',
  },
  save: {
    padding: '8px 16px',
    backgroundColor: '#4caf50',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
  },
  cancel: { padding: '8px 16px', marginLeft: 10, cursor: 'pointer' },
  loading: { textAlign: 'center', padding: 40 },
  error: { color: 'red', textAlign: 'center', padding: 20 },
  footer: { marginTop: 30 },
};

export default EditTeam;
